import * as Inspector from 'node-avo-inspector';

import { avoInspectorApiKey } from './Avo';

const mapEnvToAvoEnv = (env: string) => {
  switch (env) {
    case 'production':
      return Inspector.AvoInspectorEnv.Prod;
    case 'development':
      return Inspector.AvoInspectorEnv.Staging;
    case 'local':
      return Inspector.AvoInspectorEnv.Dev;
    default:
      return Inspector.AvoInspectorEnv.Dev;
  }
};

// For tree shaking to work we must explicitly compare with process.env else it will be included in the bundle
export const AvoInspector = new Inspector.AvoInspector({
  apiKey: avoInspectorApiKey,
  env: mapEnvToAvoEnv(process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? ''),
  version: `${process.env.NEXT_PUBLIC_SENTRY_RELEASE}+${process.env.NEXT_PUBLIC_CODEBUILD_BUILD_NUMBER ?? 'latest'}`,
  appName: process.env.NEXT_PUBLIC_APP_NAME,
});

// Silence the inspector
AvoInspector.enableLogging(false);
